export type SubscriptionPlan = 'basic' | 'professional' | 'enterprise';
export type SubscriptionStatus = 'active' | 'cancelled' | 'expired';

export interface Subscription {
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  startDate: Date;
  endDate: Date;
}

export interface SubscriptionTier {
  name: SubscriptionPlan;
  price: number;
  features: string[];
  searchLimit: number;
  description: string;
}

export const subscriptionTiers: SubscriptionTier[] = [
  {
    name: 'basic',
    price: 9.99,
    features: [
      'Basic AI summary & highlights',
      'Core requirements analysis',
      'Basic timeline tracking',
      'Contact information extraction',
      'Simple market insights',
      'Email support',
      '50 searches per month'
    ],
    searchLimit: 50,
    description: 'Perfect for small businesses getting started with government contracting'
  },
  {
    name: 'professional',
    price: 29.99,
    features: [
      'Advanced AI analysis & insights',
      'Detailed technical requirements',
      'Equipment & materials analysis',
      'Budget & set-aside analysis',
      'Similar opportunities matching',
      'Custom reports & analytics',
      'Saved searches',
      'Priority email & chat support',
      '500 searches per month'
    ],
    searchLimit: 500,
    description: 'Ideal for growing businesses actively pursuing government contracts'
  },
  {
    name: 'enterprise',
    price: 49.99,
    features: [
      'Premium AI analysis engine',
      'Full competitive analysis',
      'Team collaboration features',
      'Custom integrations',
      'API access',
      'Data export capabilities',
      'Advanced market intelligence',
      'Dedicated account manager',
      'Unlimited searches'
    ],
    searchLimit: Infinity,
    description: 'Complete solution for established government contractors'
  }
];
